app.controller('popupAlertController', ['$scope', '$mdDialog', 'title', 'message',
    function ($scope, $mdDialog, title, message) {

        function setData() {
            $scope.title = (title ? title : 'T.DATA.ALERT');
            $scope.message = message;
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.ok = function () {
                $mdDialog.hide();
            };
        }

        function configureInterface() {
        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
